import { paramCase } from 'change-case'
import PropTypes from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { MobileStream } from '../sharedDisplays'
import { DesktopSingle, DesktopStream } from './displays'
import { baseStyles } from './styles'

const displays = {
  mobileStream: MobileStream,
  desktopStream: DesktopStream,
  desktopSingle: DesktopSingle,
  default: MobileStream,
}
const matchDisplay = (display) => displays[display] || displays.default

export const InstagramStandard = ({
  accountImage,
  accountUsername,
  assets,
  collabAccount,
  content,
  display,
  instagramCollab,
  isPresenting = false,
  location,
  notCropped,
  onExpandAsset,
  onRemoveAsset,
  postType,
  readOnly = false,
  truncate = false,
  updateCaption,
  updateCoverAsset,
  updateText,
}) => {
  const RenderDisplay = matchDisplay(display)
  const photo = assets.length ? assets[0] : null

  return (
    <div
      css={baseStyles({ display, maintainAspectRatio: photo && notCropped })}
      className={kuiperClassNames(
        'instagram instagram-standard',
        paramCase(display)
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountUsername}
        accountUsername={accountUsername}
        asset={photo}
        collabAccount={collabAccount}
        content={content}
        contentCharacterLimit={2200}
        instagramCollab={instagramCollab}
        isPresenting={isPresenting}
        location={location}
        maintainAspectRatio={photo && notCropped}
        onContentChange={(value) => updateText(value, 'content')}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        postType={postType}
        readOnly={readOnly}
        truncate={truncate}
        updateCaption={updateCaption}
        updateCoverAsset={updateCoverAsset}
      />
    </div>
  )
}

InstagramStandard.propTypes = {
  accountImage: PropTypes.object,
  accountUsername: PropTypes.string,
  assets: PropTypes.array,
  content: PropTypes.string,
  collabAccount: PropTypes.string,
  display: PropTypes.oneOf(['mobileStream', 'desktopStream', 'desktopSingle']),
  instagramCollab: PropTypes.bool,
  isPresenting: PropTypes.bool,
  location: PropTypes.string,
  notCropped: PropTypes.bool,
  onExpandAsset: PropTypes.func,
  onRemoveAsset: PropTypes.func,
  postType: PropTypes.string,
  readOnly: PropTypes.bool,
  truncate: PropTypes.bool,
  updateCaption: PropTypes.func,
  updateCoverAsset: PropTypes.func,
  updateText: PropTypes.func,
}
